<template>
  <v-row>
    <v-col lg="10" class="mx-auto">
      <v-card class="pa-4">
        <v-form>
          <p class="subtitle-2 mb-1">{{ $t('目前身份') }}</p>
          <p>{{ user.vendor.no }} {{ user.vendor.name }}</p>
          <p class="subtitle-2 mb-0">
            <label for="identityType">{{ $t('請選擇證件類別') }}</label>
            <v-select
            id="identityType"
            :items="identityTypes"
            item-text="text"
            item-value="value"
            v-model="identityType"
          ></v-select>
          </p>
          <p class="subtitle-2 mb-0">
            <label for="file">{{ $t('上傳檔案') }}</label>
          </p>
          <p>
            <v-file-input ref="fileInput" :placeholder="$t('上傳檔案')" accept=".csv, .tsv, .xls, .xlsx" @change="file => this.file = file"></v-file-input>
          </p>
          <v-btn color="primary" large block @click="submit" :loading="isLoading" :disabled="!file">
            <v-icon>mid-magnify</v-icon>
            {{ $t('確定送出') }}
          </v-btn>
          <v-btn color="secondary" large block @click="sample" class="mt-2" v-show="!file && !batchNumber">
            <v-icon>mid-magnify</v-icon>
            {{ $t('下載格式') }}
          </v-btn>
          <v-btn color="success" large block @click="download" class="mt-2" v-show="batchNumber">
            <v-icon>mid-magnify</v-icon>
            {{ $t('下載查證結果') }}
          </v-btn>
        </v-form>
      </v-card>
      <v-card class="pa-4 mt-4" v-if="items.length">
        <query-logs-table
          :isLoading="isLoading"
          :items="items"
          :items-per-page="-1"
          >
        </query-logs-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { date } from '../../libs/filters';
import { mapState, mapActions } from 'vuex';
import QueryLogsTable from '../../components/QueryLogsTable';

export default {
  components: {
    QueryLogsTable,
  },

  data() {
    return {
      isLoading: false,
      identityType: 'passport',
      file: null,
      batchNumber: null,
      items: [],
    };
  },

  computed: {
    identityTypes() {
      return [
        {
          text: this.$t('護照號碼'),
          value: 'passport',
        },
        // {
        //   text: this.$t('身分證字號'),
        //   value: 'ID',
        // },
      ];
    },
    ...mapState('queries', {
      queryLogs: 'all'
    }),
    ...mapState(['user']),
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.user.vendor.can_batch) {
        next('/');
      }
    });
  },

  methods: {
    onFileChange(files) {
      console.log(files);
      if (!files) {
        return;
      }

      this.file = file;
    },

    async submit() {
      this.isLoading = true;
      try {
        let logs = await this.batch({
          identity_type: this.identityType,
          vendor_id: this.user.vendor.id,
          file: this.file,
        });

        this.items = logs;
        this.batchNumber = logs[0].batch;
        this.$refs.fileInput.reset();
      } catch (error) {
        console.error(error);
        alert(this.$t('大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝'));
      }
      this.isLoading = false;
    },

    download() {
      window.open(`/logs/download?batch=${this.batchNumber}`, '_blank');
    },

    sample() {
      window.open(`/batch/sample`, '_blank');
    },

    ...mapActions('queries', {
      'batch': 'batch'
    }),
  },
}
</script>
